import React from 'react';
import { Formats } from '@spins/react-ui-library';
import numbro from 'numbro';

export interface ColoredValueProps {
  decimals?: number;
  isPositiveColored?: boolean;
  showPositiveSign?: boolean;
  value: number;
  type: 'number' | 'currency' | 'percentage';
}

const ColoredValue: React.FC<ColoredValueProps> = ({
  decimals = 0,
  isPositiveColored = true,
  showPositiveSign = true,
  value,
  type = 'percentage'
}) => {
  let formattedValue;
  switch (type) {
    case 'number':
      formattedValue = Formats.number(value, { decimals, showSign: showPositiveSign });
      break;
    case 'currency':
      formattedValue = Formats.currency(value, { decimals, showSign: showPositiveSign });
      break;
    case 'percentage':
      formattedValue = Formats.percentage(value, { decimals, showSign: showPositiveSign });
      break;
  }

  const valueForColor = numbro(numbro(value).format({ mantissa: decimals })).value();
  let color: string = 'inherit';
  if (valueForColor > 0) {
    color = '#28a745';
  } else if (valueForColor < 0) {
    color = '#dc3545';
  }
  return <span style={{ color }}>{formattedValue}</span>;
};

export default ColoredValue;
